import { htmlSafe } from '@ember/template';
import { SafeString } from '@ember/template/-private/handlebars';

export default function cardIndicatorColorStyle(
  color?: string
): SafeString | undefined {
  return color ? htmlSafe(`--card-indicator-color: ${color};`) : undefined;
}
